export default __webpack_public_path__ + "71f0e5f97308d143728d9a75c4cf74ae.png";